// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kiieWWzmOIqE5W3k9s8v{padding:12px 20px 20px}.ULKwlRM1UH8f93iE11HK{background-color:var(--background-neutral-default);border-radius:50%;justify-content:center;align-items:center;width:28px;height:28px;margin:0 8px;display:flex}.iVf83E3F6RUDTgf1JyU5{width:310px}.KdMAdQmycwIRhuEwGPGB{width:32px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `kiieWWzmOIqE5W3k9s8v`,
	"typeIcon": `ULKwlRM1UH8f93iE11HK`,
	"selectChannel": `iVf83E3F6RUDTgf1JyU5`,
	"refreshButton": `KdMAdQmycwIRhuEwGPGB`
};
export default ___CSS_LOADER_EXPORT___;
